import { useState, useEffect } from 'react';

export const useDateTime = () => {
  const [dateTime, setDateTime] = useState<string>('');

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const options: Intl.DateTimeFormatOptions = { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric', 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit' 
      };
      
      let dateTimeString = now.toLocaleDateString('es-ES', options);

      const capitalizeFirstLetter = (string: string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
      };

      const parts = dateTimeString.split(' ');
      if (parts.length > 0) {
        parts[0] = capitalizeFirstLetter(parts[0]); // Capitalize day
      }
      if (parts.length > 2) {
        parts[2] = capitalizeFirstLetter(parts[2]); // Capitalize month
      }
      dateTimeString = parts.join(' ');

      setDateTime(dateTimeString);
    };

    // Initial call
    updateDateTime();
    
    // Update every second
    const interval = setInterval(updateDateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return dateTime;
};
